import React from 'react';
import { useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import FavoriteIconController from 'shared/icons/favourite/favoriteIconController';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { useTranslation } from 'react-i18next';
import ActionInlineButton from 'shared/lib/components/controls/buttons/actionInlineButton';

export default function FavoritesButton({
  isFavorite,
  onToggle,
  toFavoriteText,
  fromFavoriteText,
}: {
  isFavorite: boolean;
  onToggle: () => Promise<void>;
  toFavoriteText?: string;
  fromFavoriteText?: string;
}) {
  const theme = useTheme();
  const {
    mobxStore: {
      authStore: { user },
    },
  } = useContext(MobxContext);
  const { t } = useTranslation();

  toFavoriteText = toFavoriteText || t('noCategory.toFavorite');
  fromFavoriteText = fromFavoriteText || t('noCategory.inFavorite');

  return (
    <ActionInlineButton
      sx={{
        justifyContent: user?.isOnlyView ? 'start' : 'end',
      }}
      {...(isFavorite
        ? {
            defaultIconColor: theme.palette.custom.isFavourite,
          }
        : {})}
      Icon={observer((props) => {
        return (
          <FavoriteIconController
            isFavourite={isFavorite}
            {...props}
          ></FavoriteIconController>
        );
      })}
      onClick={onToggle}
    >
      {isFavorite ? fromFavoriteText : toFavoriteText}
    </ActionInlineButton>
  );
}
